import EmberRouter from '@ember/routing/router';
import config from './config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function() {
  this.route('activators');
  this.route('devices');
  this.route('translations');
  this.route('history');
  this.route('monitor');
  this.route('upload');
  this.route('tools',function()
  {
    this.route('startTimes');	
	this.route('tester');	
  });
});
